import React from 'react';
import {View} from 'react-native';

import FormattedNumber from '/component/base/FormattedNumber/FormattedNumber';
import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './ScheduledPremierOrder.style';
interface ScheduledPremierOrderProps {
  tt: (key: string, cb: any) => React.ReactNode;
  item: {
    nextScheduledPremierOrder?: {
      scheduledOn: string | Date;
      price: {
        total: number;
        currencyCode: string;
      };
    };
  } | null;
}

export const ScheduledPremierOrder: React.FC<ScheduledPremierOrderProps> = ({
  tt,
  item,
}) => {
  const scheduledOn = item?.nextScheduledPremierOrder?.scheduledOn;
  const price = item?.nextScheduledPremierOrder?.price;

  if (!scheduledOn || !price) return null;

  return (
    <View
      style={styles.base}
      {...testProperties(Reports.reportScheduledPremierOrder)}>
      {tt(
        'scheduledOn',
        generateComponentCallback({
          component: (
            <Text>
              Scheduled for{' '}
              {getDateUtilDefaultInstance().formatDate(scheduledOn, 'MMMM d')}
            </Text>
          ),
        }),
      )}
      <Text> · </Text>
      <FormattedNumber
        value={price.total}
        decimalPlaces={2}
        boldText={false}
        currencyCode={price.currencyCode}
      />
    </View>
  );
};

export default withTranslation('report.record.scheduledPremierOrder')(
  ScheduledPremierOrder,
);
